import React from 'react';
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap';
import OfferTable from '../Components/OfferTable';
import TenderNotClosedAlert from '../Components/TenderNotClosedAlert';
import {
  canAccessEvaluationOperationalData,
  getEvaluationOperationalLockReason,
} from '../../../../utils/tenderEvaluationHelpers';

const TabOffer = ({
  procurement,
  procId,
  isLoadingProcurement,
  parcels = [],
  isLoadingParcels = false,
  onSelectedOffersChange,
  selectionClearToken = 0,
  isActive = true,
}) => {
  if (isLoadingProcurement && !procurement) {
    return (
      <div className='text-center py-4'>
        <Spinner size='sm' color='primary' />
        <p className='text-muted mt-2'>Loading offer data...</p>
      </div>
    );
  }

  const lockReason = getEvaluationOperationalLockReason(procurement);
  const canAccessData = canAccessEvaluationOperationalData(procurement);

  return (
    <Card className='border shadow-md mb-4'>
      <CardBody>
        <div className='mb-4'>
          <h5 className='fw-bold text-dark mb-1'>Offer Detail</h5>
          <p className='text-muted small mb-0'>
            Bisa jadi Kalimat tambahan untuk membantu section mengenai apa ini.
          </p>
        </div>

        {!canAccessData ? (
          <TenderNotClosedAlert featureLabel='Offer' reason={lockReason} />
        ) : (
          <Row className='mt-3'>
            <Col md={12}>
              <OfferTable
                procurementId={procurement?.id || procId}
                procurement={procurement}
                parcels={parcels}
                isLoadingParcels={isLoadingParcels}
                onSelectedOffersChange={onSelectedOffersChange}
                selectionClearToken={selectionClearToken}
                isActive={isActive}
              />
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

export default TabOffer;
